import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { IDropdownHieararchy } from "../interfaces/idropdownconfig";
import { DropdownHierarchyService } from "../services/dropdownhierarchy.service";

@Injectable()
export class DropDownHierarchyResolver implements Resolve<IDropdownHieararchy> {
    constructor(private dropdownHiearchyService : DropdownHierarchyService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IDropdownHieararchy> {
        return this.dropdownHiearchyService.getHierarchy();
    }
}

